import { Component, OnInit } from '@angular/core';
import { ServicesService } from '../services.service';
import {environment} from '../../environments/environment';
import {ActivatedRoute, Router } from '@angular/router';
import swal from 'sweetalert2';

@Component({
  selector: 'app-orderdetail',
  templateUrl: './orderdetail.component.html',
  styleUrls: ['./orderdetail.component.css']
})
export class OrderdetailComponent implements OnInit {
    apiBaseUrl: string        = environment.apiBaseUrl;
    header                    = 'l-header';
    navbar                    = 'l-navbar l-navbar_t-light l-navbar_expand js-navbar-sticky';
    getCartDetailResults: any = '';
    productArray              =[];
    orderId;
    totalPrice                = 0;
    orderDate;
    orderNumber;
    isTransaction;
    isOrderSuccess            = false;
    isOrderFailed             = false;

    subTotalshow              = 0; 
    taxTotal                  = 0;
    finalAmountshow           = 0;
    onlineFee                 = 0;

  constructor( private route: ActivatedRoute, private _service: ServicesService, private router: Router) { 

    this.route.params.subscribe( params => {
        this.orderId = params['order_id'];
        this.isTransaction = params['is_transcation']?params['is_transcation']:0;
    })
  }

  ngOnInit() {
      /*
        this.route.queryParams.subscribe(params => {
          this.orderId = params['order_id'];
          this.isTransaction = params['is_transcation']?params['is_transcation']:0;
         // console.log('This is jobid ' + this.orderId);
      });
      */
      this.getOrderDetails(this.orderId,this.isTransaction);
  }

    showImage(src) {

        const imgUrl = this.apiBaseUrl + '/' + src;
        // console.log(imgUrl);
        swal({
            html:  "<img src='" + imgUrl + "' style='width:100%;'>",
            showConfirmButton: false,
            customClass: 'swal-wide',
        });
    }

    getOrderDetails(orderId, transcation) {
        const userData = JSON.parse(localStorage.getItem('userData'));
        const token = localStorage.getItem('userToken');
        
        const user_id     = userData.hasOwnProperty('id') ?  userData.id : '';
        const data = {'order_id' : orderId, 'token': token };
        
        this._service.getOrderDetails(data).subscribe((result: any) => {

        $('.tb-preloader-wave').fadeOut();
        $('#tb-preloader').delay(200).fadeOut('slow').remove();

          if (result.status === 200) {
              this.isOrderSuccess = transcation == 1 ? true : false;
              this.getCartDetailResults = result.result;
              for (const obj in   this.getCartDetailResults) {
                  this.productArray.push(this.getCartDetailResults[obj]);
              }
              this.orderNumber = this.productArray[0]['order_number'];
              this.totalPrice = this.productArray[0]['amount'];
              this.orderDate  = this.productArray[0]['order_date'];
              
              this.productArray.map(function(productArray){
                this.amount =  this.getSubTotalAmoutShow(productArray.price); 
                  productArray.price=this.amount;    
           },this);

          }else {
              this.isOrderFailed = transcation == 1 ? true : false;
              // this.router.navigate(['login']);

          }

            // console.log('getCartDetailResults', this.productArray);
        });
    }


    getSubTotalAmoutShow(price){
        
        this.subTotalshow = price*1;
        this.taxTotal = ((this.subTotalshow) * 15) / 100;
        this.finalAmountshow =   this.subTotalshow + this.taxTotal;
        this.onlineFee = 1.5 + (this.finalAmountshow *3.5)/100;
        this.finalAmountshow =  1*(this.onlineFee + this.finalAmountshow);
       
        return  this.finalAmountshow;
       
    }

}



// WEBPACK FOOTER //
// /var/www/html/oneills-web-qa/src/app/orderdetail/orderdetail.component.ts